<template>
  <v-container>
    <h1 class="display-1 pt-3">Users by Course</h1>
    <a-l-courses class="mt-2" />
  </v-container>
</template>
<script>
import courses from "./components/allcourses";
export default {
  components: {
    "a-l-courses": courses
  }
};
</script>
